const types = {
  GET_CURRENT_CUSTOMER_LOGO_STARTED: '@drivex/configuration/GET_CURRENT_CUSTOMER_LOGO_STARTED',
  GET_CURRENT_CUSTOMER_LOGO_SUCCESS: '@drivex/configuration/GET_CURRENT_CUSTOMER_LOGO_SUCCESS',
  GET_CURRENT_CUSTOMER_LOGO_FAILURE: '@drivex/configuration/GET_CURRENT_CUSTOMER_LOGO_FAILURE',
  STORE_CUSTOMER_CONFIGURATIONS: '@drivex/configuration/STORE_CUSTOMER_CONFIGURATIONS',
  SET_CAMERA_ACCESS_DENIED_SUCCESS: '@drivex/configuration/SET_CAMERA_ACCESS_DENIED_SUCCESS',
  SET_SERVICE_UNAVAILABLE_SUCCESS: '@drivex/configuration/SET_SERVICE_UNAVAILABLE_SUCCESS',
  SET_GEOLOCATION_ACCESS_NEEDED_SUCCESS: '@drivex/configuration/SET_GEOLOCATION_ACCESS_NEEDED_SUCCESS',
  SET_GEOLOCATION_ENABLED_SUCCESS: '@drivex/configuration/SET_GEOLOCATION_ENABLED_SUCCESS'
};

export { types };
